export default "__VITE_ASSET__niQsww2R__"